import { render, staticRenderFns } from "./DropdownEx.vue?vue&type=template&id=52929234&shadow"
import script from "./DropdownEx.vue?vue&type=script&lang=js&shadow"
export * from "./DropdownEx.vue?vue&type=script&lang=js&shadow"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports